// eslint-disable-next-line no-restricted-imports
import axios from "axios";
import { toValue } from "vue";
import { useFetch } from "@/core/api/common";
import { Logger } from "@/core/utilities";

export async function downloadFile(fileUrl: string, fileName: string) {
  try {
    const { data } = await useFetch(fileUrl).blob();
    const url = window.URL.createObjectURL(toValue(data) as Blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    Logger.error(downloadFile.name, error);
  }
}

// This function was created to download a file from the blob storage.
// It uses a new axios client to avoid issues with the default client, like setting an authorization header when it's not needed.
export async function downloadFileWithNewClient(fileUrl: string, fileName: string) {
  try {
    const newClient = axios.create();
    const response = await newClient.get(fileUrl, { responseType: "blob" });
    const url = window.URL.createObjectURL(response.data as Blob)
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    Logger.error(downloadFile.name, error);
  }
}
